// Uděláno takto natvrdo, abych nemusel přepojovat na novější mc balíček, ve kterém to asi je, ale přepnutí se trošku bojím

export const values = ["DOKLAD_CISLO", "JMENO_PRIJMENI_DATUMNAR"]

export const DOKLAD_CISLO = "DOKLAD_CISLO"
export const JMENO_PRIJMENI_DATUMNAR = "JMENO_PRIJMENI_DATUMNAR"

